import { createReducer } from "@ngrx/store";
import { initialApplicationStore } from "./application.state";

// Nested reducers (array format)
import { authenticationReducer } from "./authentication/authentication.reducer";
import { clipboardReducer } from "./clipboard/clipboard.reducer";
import { dataReducer } from "./data/data.reducer";
import { settingsReducer } from "./settings/settings.reducer";
import { notificationReducer } from "./notification/notification.reducer";

// **************************************************************************
// APPLICATION REDUCER (consolidated)
// User and Navigation are standalone stores
// **************************************************************************
export const applicationReducer = createReducer(
    initialApplicationStore,

    // **************************************************************************
    // AUTHENTICATION HANDLERS
    // **************************************************************************
    ...authenticationReducer,

    // **************************************************************************
    // CLIPBOARD HANDLERS
    // **************************************************************************
    ...clipboardReducer,

    // **************************************************************************
    // DATA HANDLERS
    // **************************************************************************
    ...dataReducer,

    // **************************************************************************
    // SETTINGS HANDLERS
    // **************************************************************************
    ...settingsReducer,

    // **************************************************************************
    // NOTIFICATION HANDLERS
    // **************************************************************************
    ...notificationReducer,
);
